import React, { useReducer, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";

import {
  INIT_TVSCREEN,
  SET_LIFECYCLE_DATA,
  SET_LIFECYCLE_STATE,
  SET_LIFECYCLE_DRAW,
  JACKPOT_HIT,
  JACKPOT_UPDATE,
  STATISTICS,
  WINNINGPLAN,
  SET_TIPS_TO_CASHIER,
  DRAW
} from "./app/containers/App/actions";

import i18n from "./i18n";
import appReducer, { initialState } from "./app/containers/App/reducer";
import Routes from "./Routes";
import GlobalDataContext from "./GlobalDataContext";
import PreLoader from "./app/components/PreLoader/PreLoader";
// import ModalWindows from "./app/components/ModalWindows";

const AppIndex = () => {
  const [state, dispatch] = useReducer(appReducer, initialState);
  // eslint-disable-next-line

  useEffect(() => {
    if (i18n.language === "ru")
      document.body.classList.add("smaller-font-size");

      const $tvscreen = document.getElementById("tvscreen");
      const $jackpotStatus = document.getElementById("jackpotStatus")
      const $lifecycleData = document.getElementById("lifecycleData")
      const $sendtipstocashier = document.getElementById("sendTipsToCashier")


    $sendtipstocashier.addEventListener("receiveMessage", (e) => {
      console.log("sendtipstocashier", JSON.parse($sendtipstocashier.value));
      dispatch({
        type: SET_TIPS_TO_CASHIER,
        payload: JSON.parse($sendtipstocashier.value)
      });
    });

      $tvscreen.addEventListener("receiveMessage", () => {
          const tvscreen = $tvscreen.dataset.initTvscreen;
          console.log("tvscreen", JSON.parse(tvscreen));
          dispatch({
            type: INIT_TVSCREEN,
            payload: JSON.parse(tvscreen)
          });
        });


    $jackpotStatus.addEventListener("receiveMessage", () => {
        const jackpotStatus = $jackpotStatus.dataset.jackpotStatus;
        console.log("jackpotStatus", JSON.parse(jackpotStatus));
        dispatch({
          type: JACKPOT_UPDATE,
          payload: JSON.parse(jackpotStatus)
        });
      });

    $lifecycleData.addEventListener("receiveMessage", () => {
        const lifecycledata = $lifecycleData.dataset.lifecycleData;
        console.log("lifecycledata", JSON.parse(lifecycledata));

        if (JSON.parse(lifecycledata).LifeCycleStatus === JACKPOT_HIT) {
          dispatch({
            type: JACKPOT_HIT,
            payload: JSON.parse(lifecycledata)
          });
          dispatch({
            type: "OPEN_MODAL_WINDOW",
            payload: "jackpotHit"
          });
        } else if (JSON.parse(lifecycledata).LifeCycleStatus === STATISTICS) {
          dispatch({
            type: STATISTICS,
            payload: JSON.parse(lifecycledata)
          });
        } else {
          // save winningplan data in lifecycle property of global state
          if (JSON.parse(lifecycledata).LifeCycleStatus === WINNINGPLAN) {
            dispatch({
              type: SET_LIFECYCLE_DATA,
              payload: JSON.parse(lifecycledata)
            });
          } else if (JSON.parse(lifecycledata).LifeCycleStatus === DRAW) {
            dispatch({
              type: SET_LIFECYCLE_DRAW,
              payload: JSON.parse(lifecycledata)
            });
          }

          dispatch({
            type: SET_LIFECYCLE_STATE,
            payload: JSON.parse(lifecycledata).LifeCycleStatus
          });
        }
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (state.appSettings.Language)
      i18n.changeLanguage(state.appSettings.Language);
  }, [state.appSettings.Language]);

  return (
    <GlobalDataContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Routes />
      <PreLoader isLoading={false} />
      {/*modal windows with theirs event listeners functions*/}
      {/*<ModalWindows*/}
      {/*  toggleModal={()=>console.log('toggleModal')}*/}
      {/*/>*/}
    </GlobalDataContext.Provider>
  );
};

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <AppIndex />
  </I18nextProvider>,
  document.getElementById("root")
);
